import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from '../util_grid/grid.js';
import Ankeiler from '../sec_ankeiler/component';
import './styles/grid.scss';

class Grid extends Component {
  get items() {
    // If component has name or text, append a text ankeiler
    const { text, name, url, products } = this.props;
    let items = products || this.props.items || [];
    if (text || name) {
      items = [{ text, name, url, variant: 'text' }, ...items];
    }
    return items.map((product, index) => {
      if (index === 0 && this.props.showHighlight) {
        return {
          ...product,
          variant: 'highlight',
          action: this.props.highlightText || '',
        };
      }
      return {
        ...product,
      };
    });
  }

  get numerical() {
    return this.props.numerical || false;
  }

  get pageSize() {
    return this.props.pageSize || 24;
  }

  get currentPage() {
    return this.props.currentPage || false;
  }

  get store() {
    return this.props.store;
  }

  get lastItemOverlay() {
    return this.props.lastItemOverlay;
  }

  /**
   * create the badgeValue if needed
   */
  composeBadgeValue(i) {
    return this.numerical ? (i + 1) + (this.currentPage * this.pageSize) : null;
  }

  render() {
    const { listType } = this.props;
    const lastItemIndex = this.items.length - 1;

    return (
      <div className="grid">
        <Row>
          {this.items.map((elem, i) => {
            const variant = (listType === 'list') ? listType : (elem.variant || 'medium');
            return (
              <div className={`column-${variant}`} key={`${i}-${elem.url}-${variant}`}>
                {(lastItemIndex === i) && this.lastItemOverlay}
                <div className={`grid-element-wrapper ${variant}`}>
                  {(elem.text || (elem.price && Object.keys(elem.price).length > 0)) && (
                    <Ankeiler
                      {...elem}
                      variant={variant}
                      store={this.store}
                      xs={12} sm={12} md={12}
                      classes="expandable"
                      badgeValue={this.composeBadgeValue(i)}
                      position={i + 1}
                    />
                  )}
                </div>
              </div>);
          })}
        </Row>
        <Row style={{ marginBottom: '-1px' }} key="rowfix"></Row>
      </div>
    );
  }
}


Grid.propTypes = {
  /**
   * the store
   */
  store: PropTypes.object,
  /**
   * Ankeiler medium items to display inside grid
   *
   */
  numerical: PropTypes.bool,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  items: PropTypes.array,
  /**
   * lastItemOverlay react element that can be used as a overlay item on the last item in the grid
   *
   */
  lastItemOverlay: PropTypes.element,
  layout: PropTypes.string,
  listType: PropTypes.oneOf(['list', 'grid']),
  showHighlight: PropTypes.bool,
  products: PropTypes.array,
  highlightText: PropTypes.string,
  text: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
};


export default Grid;
